/**
 * External dependencies
 */
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { confirmAlert } from 'react-confirm-alert'; // Import
import { find } from 'lodash';

/**
 * Internal dependencies
 */
import Card from 'components/card';
import { requestPlansIfNotRequested } from 'state/support-plans/actions';
import { getAllSupportPlans, requestingSupportPlans } from 'state/support-plans/selectors';
import { swapSubscription } from 'state/subscriptions/actions';
import { getCurrentSupportId, getCurrentSupportPlanId, getCurrentSupport } from 'state/current-support/selectors';
import { successNotice } from 'state/notices/actions';
import { requestAddonsIfNotRequested } from 'state/addons/actions';
import Loader from './loader';
import { getAllAddons } from 'state/addons/selectors';
import Plan from './plan';
import Preloader from 'components/preloader';
import cscom from 'lib/customer-site-api';
import cb from 'lib/chargebee';
import Money from 'components/money';
import ConfirmNewPlanAlert from './confirm-new-plan-alert'; // Import
import { requestCurrentSupport } from 'state/current-support/actions';
import { getCurrentUser } from 'state/current-user/selectors';
import { requestCouponsIfNotRequested } from 'state/coupons/actions';
import { Box, Stack } from '@towersystems/towersystems-design-system';

/**
 * Style dependencies
 */
import './styles.scss';
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css

const SelectSupportPlan = (props) => {
    const supportPlans = props.supportPlans;
    const [submitting, setSubmitting] = useState(false);

    const onChange = (value) => {
        if (!props.supportsubscriptionId) {
            return newSubscription(value);
        }

        let plan = find(supportPlans, { id: value });
        let addon = resolveLicenseAddon(plan);

        confirmAlert({
            title: 'Change Support Plan',
            message: 'Are you sure to do this. Changes will take affect next billing period.',
            submitting,
            closeOnEscape: false,
            closeOnClickOutside: false,
            customUI: ({ onClose }) => (
                <ConfirmNewPlanAlert
                    currentSupport={props.currentSupport}
                    subscriptionId={props.supportsubscriptionId}
                    newPlanId={plan.id}
                    plan={plan}
                    addon={addon}
                    onClose={onClose}
                    onSubmit={() => handleSubmit(value)}
                />
            ),
        });
    };

    useEffect(() => {
        props.requestSupportPlans();
        props.requestAddons();
        props.requestCoupons();
    }, []);

    const handleSubmit = (value) => {
        setSubmitting(true);
        return props
            .swapSubscription(props.supportsubscriptionId, value)
            .then((s) =>
                props.successNotice(
                    'Your support subscription will be updated at the end of the current billing period.',
                ),
            )
            .then(() => props.afterSuccess && props.afterSuccess())
            .finally(() => setSubmitting(false));
    };

    const newSubscription = (planId) => {
        cb.openCheckout({
            hostedPage: () => cscom.hostedPage().newSubscription(planId),
            error: (e) => console.log(e),
            close: () => {},
            success: () => {
                props.requestCurrentSupport();
                props.successNotice('Your support subscription has been created.');
            },
        });
    };

    const resolveLicenseAddon = (plan) => {
        const addon = find(plan.applicable_addons, {
            id: 'support#additional-ms-license#' + plan.period + plan.period_unit,
        });

        if (addon) {
            return find(props.addons, { id: addon.id });
        }

        return null;
    };

    if (props.requesting) {
        return <Loader />;
    }

    return (
        <form onSubmit={handleSubmit}>
            <Box>
                <Stack space='xxlarge'>
                    {supportPlans.map((plan, i) => {
                        return (
                            <Plan
                                key={plan.id}
                                plan={plan}
                                onClick={() => onChange(plan.id)}
                                disabled={
                                    !(props.currentSupport && props.currentSupport.status == 'cancelled')
                                        ? plan.id == props.supportPlanId
                                        : null
                                }
                                licenseAddon={resolveLicenseAddon(plan)}
                                numberLicenses={props.currentUser.additionalLicenses}
                            />
                        );
                    })}
                </Stack>
            </Box>
        </form>
    );
};

export default connect(
    (state) => ({
        supportPlans: getAllSupportPlans(state),
        addons: getAllAddons(state),
        supportsubscriptionId: getCurrentSupportId(state),
        supportPlanId: getCurrentSupportPlanId(state),
        currentSupport: getCurrentSupport(state),
        currentUser: getCurrentUser(state),
        requesting: requestingSupportPlans(state),
    }),
    {
        requestSupportPlans: requestPlansIfNotRequested,
        requestCurrentSupport,
        requestCoupons: requestCouponsIfNotRequested,
        swapSubscription,
        successNotice,
        requestAddons: requestAddonsIfNotRequested,
    },
)(SelectSupportPlan);
